import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Game from './pages/Game';
import ErrorBoundary from './components/ErrorBoundary';
import { COPY } from './copy';

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-dark-navy">
        <header className="bg-dark-charcoal border-b-2 border-neon-cyan shadow-glow-cyan">
          <div className="container mx-auto px-4 py-4">
            <h1 className="text-3xl font-bold text-neon-cyan text-glow-cyan">
              {COPY.app.title}
            </h1>
            <p className="text-sm text-gray-300">
              {COPY.app.tagline}
            </p>
          </div>
        </header>

        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/game/:sessionId" element={<Game />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <footer className="bg-dark-charcoal text-gray-400 text-center py-4 mt-auto border-t border-neon-cyan/20">
          <p className="text-sm">
            {COPY.app.footer.license}
          </p>
        </footer>
      </div>
    </ErrorBoundary>
  );
}

function NotFound() {
  return (
    <div className="text-center py-16">
      <h2 className="text-4xl font-bold text-neon-pink mb-4 text-glow-pink">
        {COPY.app.notFound.title}
      </h2>
      <p className="text-gray-300 mb-4">{COPY.app.notFound.message}</p>
      <a
        href="/"
        className="text-neon-cyan hover:text-neon-pink transition-colors"
      >
        {COPY.app.notFound.action}
      </a>
    </div>
  );
}

export default App;
